import React from "react";
import { cn } from "../utils";
import { typography } from "../tokens";

export function EmptyState({ children, className, height = 180 }) {
  return (
    <div
      className={cn("flex items-center justify-center text-gray-300", className)}
      style={{ height, ...typography.subtitle }}
    >
      {children}
    </div>
  );
}

export function EmptyStateInline({ children, className }) {
  return (
    <div className={cn("py-8 text-center text-gray-300", className)} style={typography.subtitle}>
      {children}
    </div>
  );
}
